import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  notification,
  Row,
  Button,
  Modal,
  Form,
  Input,
  Select,
} from "antd";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  StarFilled,
  StarOutlined,
  PhoneOutlined,
} from "@ant-design/icons";
import map_locationIcon from "../../assets/images/restaurant/map_locationIcon.svg";
import { useNavigate, useParams } from "react-router-dom";
import {
  _get_single_restaurant_order_details,
  _submit_buyer_help_request,
  _get_business_support_team,
  _confirm_fc_items,
  _confirm_special_pickup,
} from "../../common/axios_services";
import {
  showSuccessNotification,
  showErrorNotification,
} from "../../common/utils/notification";
import FooterDisplay from "../../components/footer";
import { normalizeBusinessType } from "../../utils/businessTypeHelpers";
import { message } from "antd";

const TrackOrder = () => {
  const navigate = useNavigate();
  const { id: orderId } = useParams();
  const [spinnerLoading, setSpinnerLoading] = useState(false);
  const [order, setOrder] = useState({});
  const [orderitems, setOrderItems] = useState([]);
  const [confirmationPin, setConfirmationPin] = useState("");
  const [trackId, setTrackId] = useState("");
  const [orderHistory, setOrderHistory] = useState({});
  const [helpModalVisible, setHelpModalVisible] = useState(false);
  const [supportManager, setSupportManager] = useState(null);
  const [fetchingSupport, setFetchingSupport] = useState(false);
  const [helpForm] = Form.useForm();
  const [helpSubmitting, setHelpSubmitting] = useState(false);

  const openNotificationWithIcon = (type, message) => {
    notification[type]({
      description: message,
    });
  };

  const getOrderHist = async () => {
    try {
      setSpinnerLoading(true);
      const get_hist = await _get_single_restaurant_order_details(orderId);
      const responseData = get_hist.data.data?.data || {};

      // Set order data from new payload structure
      setOrder(responseData);
      setOrderItems(responseData.orderItems || []);
      setConfirmationPin(responseData.pickupCode || responseData.id);
      setTrackId(responseData.orderCode || responseData.id);

      // Keep orderHistory for backward compatibility
      setOrderHistory(responseData);

      console.log("Order data from track order", responseData);
    } catch (err) {
      if (err.response) {
        if (err.response.data.message === "Unauthorized") {
          localStorage.removeItem("konnect_token");
          navigate("/signin");
        }
        openNotificationWithIcon("error", err.response.data.message);
      } else {
        openNotificationWithIcon("error", err.message);
      }
    } finally {
      setSpinnerLoading(false);
    }
  };

  const handleHelpSubmit = async () => {
    try {
      const values = await helpForm.validateFields();
      setHelpSubmitting(true);

      await _submit_buyer_help_request(orderId, {
        orderId,
        buyerId: order.user?.id,
        triggerType: values.triggerType,
        notes: values.notes,
      });

      showSuccessNotification(
        "Help request submitted. Support team has been notified.",
        "Success",
      );
      setHelpModalVisible(false);
      helpForm.resetFields();
    } catch (error) {
      showErrorNotification(
        error?.response?.data?.message ||
        error?.message ||
        "Failed to submit help request",
        "Error",
      );
    } finally {
      setHelpSubmitting(false);
    }
  };

  useEffect(() => {
    getOrderHist();
  }, []);

  useEffect(() => {
    const fetchSupport = async () => {
      const businessId =
        order?.restaurant?.businessId ||
        order?.restaurant?.businessInfo?.id ||
        order?.restaurant?.id;
      if (businessId) {
        setFetchingSupport(true);
        try {
          const res = await _get_business_support_team(businessId);
          setSupportManager(res.data?.supportManager);
        } catch (err) {
          console.error("Error fetching support manager", err);
        } finally {
          setFetchingSupport(false);
        }
      }
    };
    fetchSupport();
  }, [order?.restaurant?.businessId]);

  return (
    <div>
      <div>
        <div className="mt-10">
          <Row justify={"center"}>
            <Col xs={24}>
              <div className="flex mx-auto">
                <h2 className="lg:text-7xl text-5xl mx-auto">
                  Track delivery - #{trackId}
                </h2>
              </div>
            </Col>
          </Row>
          <div className="flex justify-center items-center my-10 ">
            <div className="lg:w-1/2 w-full rounded-2xl border border-black py-5 px-10 ">
              <Card
                className="py-16 mb-5 flex justify-center items-center rounded-3xl border-2 border-black bg-[#03BFA6] "
                bordered={false}
              >
                <div className="h-full flex flex-col justify-center gap-y-3 mx-auto">
                  {order.status?.toLowerCase() === "waiting" ||
                    order.status?.toLowerCase() === "accepted" ||
                    order.status?.toLowerCase().includes("ready") ? (
                    <CheckCircleOutlined
                      className={"flex justify-center"}
                      style={{ fontSize: "32px", color: "white" }}
                    />
                  ) : order.status?.toLowerCase() === "rejected" ? (
                    <CloseCircleOutlined
                      className={"flex justify-center"}
                      style={{ fontSize: "32px", color: "red" }}
                    />
                  ) : (
                    ""
                  )}

                  {order.status?.toLowerCase() === "waiting" ||
                    order.status?.toLowerCase() === "accepted" ? (
                    <>
                      <h2 className="text-3xl text-center text-white ">
                        Your order has been {order.status}!
                      </h2>
                      {order.status?.toLowerCase() === "waiting" ? (
                        <p className={"text-center text-white mb-5"}>
                          Waiting for the Order to be Accepted
                        </p>
                      ) : (
                        <p className={"text-center text-white mb-5"}>
                          Waiting for the Order to be Ready
                        </p>
                      )}
                    </>
                  ) : order.status?.toLowerCase().includes("ready") ? (
                    <h2 className="text-3xl text-center text-white ">
                      Your order is ready!, Please go and Pickup your Order
                    </h2>
                  ) : order.status?.toLowerCase() === "rejected" ? (
                    <h2 className="text-3xl text-center text-white ">
                      Your order was rejected/canceled and money refunded. Would
                      you like to place an order from another restaurant?
                    </h2>
                  ) : (
                    ""
                  )}
                </div>
                {(order.status?.toLowerCase() === "accepted" ||
                  order.status?.toLowerCase().includes("ready")) && (
                    <p className="text-center text-white">
                      Give the restaurant the delivery code to receive your order
                    </p>
                  )}

                <div>
                  {order.status?.toLowerCase()?.includes("picked") && (
                    <p className={"text-white text-3xl mb-5 text-center"}>
                      Thank you for ordering from{" "}
                      {orderHistory.restaurant.name}{" "}
                    </p>
                  )}
                </div>

                <p className="text-center text-[15px] text-white">
                  Rate the restaurant
                </p>
                <div className="flex justify-center  items-center gap-3">
                  <StarFilled style={{ fontSize: "32px", color: "#FFF500" }} />
                  <StarFilled style={{ fontSize: "32px", color: "#FFF500" }} />
                  <StarFilled style={{ fontSize: "32px", color: "#FFF500" }} />
                  <StarFilled style={{ fontSize: "32px", color: "#FFF500" }} />
                  <StarOutlined style={{ fontSize: "32px", color: "#fff" }} />
                </div>
              </Card>
              {["waiting", "accepted", "ready", "picked", "rejected"].includes(
                order.status?.toLowerCase(),
              ) && (
                  <Row
                    justify={"center"}
                    className="lg:mt-16  "
                  >
                    <Col xs={24} lg={14}>
                      <Card
                        bordered={false}
                        className="w-full max-sm:mb-5 py-16 px-5 rounded-3xl border-2 border-black bg-[#EAF1E9] "
                      >
                        <div className="h-full w-full ">
                          {/*<h2 className="text-3xl text-[#44843F] ">Delivery to</h2>*/}
                          <h2 className="text-3xl text-[#44843F] ">
                            {order.deliveryType === "DELIVERY"
                              ? "Delivery Details and Contact Information"
                              : "Pick up details and Contact Information"}
                          </h2>
                          <ul>
                            <li>
                              <strong>Restaurant: </strong>
                              {order.restaurant?.name || "N/A"}
                            </li>
                            <li>
                              <strong>Customer: </strong>
                              {order.user?.firstName} {order.user?.lastName}
                            </li>
                            <li>
                              <strong>Order Status: </strong>
                              <span className="capitalize">
                                {order.status || "N/A"}
                              </span>
                            </li>
                            {(order.delivery?.distance || order.distance) && (
                              <li>
                                <strong>Delivery Distance: </strong>
                                {(order.delivery?.distance || order.distance)} km
                              </li>
                            )}
                          </ul>
                          <div className="flex items-center gap-3 text-black mt-3">
                            <span>
                              <img
                                src={map_locationIcon}
                                alt=""
                                className="w-10 h-10"
                              />
                            </span>
                            <p className="text-2xl font-bold">
                              {order.deliveryType === "DELIVERY"
                                ? `Delivery Address: ${order.user?.state || "N/A"
                                }`
                                : `${order.restaurant?.pickupAddressString || order.restaurant?.address || "N/A"}, ${order.restaurant?.pickupLga || ""
                                } ${order.restaurant?.pickupState || ""}`}
                            </p>
                          </div>
                          {order.deliveryType === "DELIVERY" && order.user?.state && (
                            <Button
                              type="link"
                              onClick={() => {
                                const address = encodeURIComponent(order.user.state);
                                window.open(`https://www.google.com/maps/search/?api=1&query=${address}`, "_blank");
                              }}
                              style={{ paddingLeft: 0, marginTop: "10px" }}
                            >
                              Track on Google Maps
                            </Button>
                          )}
                        </div>
                      </Card>
                    </Col>
                    <Col xs={24} lg={10}>
                      <Card
                        bordered={false}
                        className="w-full max-sm:my-6   py-16 px-5 rounded-3xl border-2 border-black bg-[#E9C6C66C] "
                      >
                        <div className="h-full w-full">
                          {/*<p className='font-bold' >Give rider this code after delivery</p>*/}
                          <p className="font-bold">
                            Give restaurant this code at pickup
                          </p>
                          <h2 className="text-4xl my-3 text-[#44843F]">
                            {confirmationPin}
                          </h2>
                        </div>
                      </Card>
                    </Col>
                  </Row>
                )}
              {["waiting", "accepted", "ready", "picked"].includes(
                order.status?.toLowerCase(),
              ) && (
                  <div style={{ marginTop: "20px", textAlign: "center", display: "flex", gap: "10px", justifyContent: "center", flexWrap: "wrap" }}>
                    {normalizeBusinessType(order.businessType) === "wholesale" && order.fulfillmentStage !== "FC_ITEMS_CONFIRMED" && (
                      <Button
                        type="primary"
                        style={{ backgroundColor: "#10B981", borderColor: "#10B981" }}
                        size="large"
                        onClick={async () => {
                          try {
                            await _confirm_fc_items(orderId);
                            showSuccessNotification("Items confirmed for FC delivery.");
                            getOrderHist();
                          } catch (err) {
                            showErrorNotification("Failed to confirm FC items.");
                          }
                        }}
                      >
                        Confirm Items to Deliver to FC
                      </Button>
                    )}
                    {order.business?.isSpecial && order.fulfillmentStage !== "SPECIAL_PICKUP_CONFIRMED" && (
                      <Button
                        type="primary"
                        style={{ backgroundColor: "#1890ff", borderColor: "#1890ff" }}
                        size="large"
                        onClick={async () => {
                          try {
                            await _confirm_special_pickup(orderId);
                            showSuccessNotification("Special pickup confirmed.");
                            getOrderHist();
                          } catch (err) {
                            showErrorNotification("Failed to confirm special pickup.");
                          }
                        }}
                      >
                        Confirm Special Business Pickup
                      </Button>
                    )}
                    <Button
                      type="primary"
                      icon={<PhoneOutlined />}
                      loading={fetchingSupport}
                      onClick={() => {
                        if (supportManager?.phoneNumber) {
                          window.open(`tel:${supportManager.phoneNumber}`);
                        } else {
                          message.info(
                            "Support contact not available. Please try again later.",
                          );
                        }
                      }}
                      size="large"
                    >
                      Need Help?
                    </Button>
                  </div>
                )}
            </div>
          </div>
        </div>
      </div>

      <FooterDisplay />
    </div>
  );
};

export default TrackOrder;
